<template>
  <div class="box">
    <el-form :model="info" label-position="right" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" size="small">
      <el-form-item label="版本名" prop="title">
        <el-input v-model="info.title" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item label="金额">
        <el-input v-model="info.money" placeholder="请输入金额"></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input v-model="info.ordering" placeholder="请输入排序"></el-input>
      </el-form-item>
      <el-form-item label="权限菜单">
        <div style="height: 400px; overflow-y: scroll;">
          <el-tree
            :data="treedata"
            @current-change="treeChange"
            show-checkbox
            default-expand-all
            node-key="id"
            ref="tree"
            highlight-current
            :check-strictly="true"
            :props="treeprops">
          </el-tree>
        </div>
      </el-form-item>
      <el-form-item label="功能菜单">
        <div style="height: 400px; overflow-y: scroll;">
          <el-tree
              :data="functreedata"
              @current-change="treeChange"
              show-checkbox
              default-expand-all
              node-key="id"
              ref="funcTree"
              highlight-current
              :check-strictly="true"
              :props="treeprops">
          </el-tree>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button type="button" @click="reBack()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

export default {
  data() {
    return {
      treedata: [],
      choosedata: [],
      functreedata: [],
      treeprops: {
        children: 'children',
        label: 'title'
      },
      info: {
        id: 0,
        money: '',
        title: ''
      },
      source_domain: this.config.SOURCE_DOMAIN,
      rules: {
        title: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '请输入金额', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.getMenuIndex()
    this.getFuncMenuIndex()
    if(this.$route.query.id) {
      this.info.id = this.$route.query.id
      this.getInfo()
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    getMenuIndex() {
      var that = this
      this.$api.merchant.merchantMenuIndex({},function (res) {
        if(res.errcode == 0) {
          that.treedata = res.data
        }
      })
    },
    getFuncMenuIndex() {
      var that = this
      this.$api.merchant.functionMenuIndex({},function (res) {
        if(res.errcode == 0) {
          that.functreedata = res.data
        }
      })
    },
    getInfo() {
      var that = this
      this.$api.merchant.versionDetail({id: that.info.id}, function (res) {
        if(res.errcode == 0) {
          that.info = res.data
          if(that.info.auth_ids) {
            that.$refs.tree.setCheckedKeys(that.info.auth_ids.split(','))
            // that.choosedata = that.info.auth_ids.split(',')
          }
          if(that.info.func_auth_ids) {
            that.$refs.funcTree.setCheckedKeys(that.info.func_auth_ids.split(','))
          }
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    treeChange(data, checked, ind) {
      console.log(data)
      console.log(checked)
      console.log(ind)
      // var node = this.$refs.tree.getCheckedNodes()
      // var nodes = []
      // node.filter(function (item) {
      //   nodes.push(item.id)
      // })
      // this.choosedata = nodes
    },
    submitForm(formName) {
      var choosedata = []
      var node = this.$refs.tree.getCheckedNodes()
      node.forEach(function (item) {
        choosedata.push(item.id)
      })
      var chooseTreeData = []
      var treeNode = this.$refs.funcTree.getCheckedNodes()
      treeNode.forEach(function (item) {
        chooseTreeData.push(item.id)
      })
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var param = {
            id: that.info.id,
            title: that.info.title,
            ordering: that.info.ordering,
            money: that.info.money,
            ids: choosedata,
            func_ids: chooseTreeData
          }
          if(this.info.id == 0) {
            this.$api.merchant.versionAdd(param,function (res) {
              if(res.errcode == 0) {
                that.success(res.errmsg)
                that.reBack()
              } else {
                that.fail(res.errmsg)
              }
            })
          } else {
            this.$api.merchant.versionEdit(param,function (res) {
              if(res.errcode == 0) {
                that.success(res.errmsg)
                that.reBack()
              } else {
                that.fail(res.errmsg)
              }
            })
          }
        } else {
          return false;
        }
      });
    },
  }
};
</script>
<style scoped>
  .box {
    background-color: #fff;
    padding: 20px;
    border-radius: 6px;
    min-height: 500px;
  }
  .ruleForm {
    width: 600px;
  }
</style>
